import {getPost, listPosts, listRelatedPosts} from "seu-frontend/graphql/post";

const defaultState = () => ({
  lang: 'EN', //check
  mappedPosts: {},
  posts: [],
  relatedPosts: [],

  pagination: {
    page: 1,
    rowsPerPage: 10,
    sortBy: [
      {
        field: 'createdAt',
        descending: true
      }
    ]
  },
  filter: null
})

export default {
  namespaced: true,

  actions: {
    getPost({commit}, input) {
      return getPost(input)
        .then(post => {
          commit('setPostInMap', post)
          return post
        })
    },
    listPosts({commit, state}, input) {
      return listPosts(input)
        .then(posts => {
          commit('setPosts', posts.result)
          commit('setPagination', posts.pagination)
          return posts
        })
    },
    listRelatedPosts({commit, state}, input) {
      return listRelatedPosts({
        ...input,
        pagination: {
          page: 1,
          rowsPerPage: 2,
          sortBy: [
            {
              field: 'createdAt',
              descending: true
            }
          ]
        }
      })
        .then(posts => {
          commit('setRelatedPosts', posts.result)
          commit('setPagination', posts.pagination)
          return posts
        })
    },
  },

  mutations: {
    setPostInMap(state, post) {
      state.mappedPosts = {
        ...state.mappedPosts,
        [post.details.slug]: post
      }
    },
    setPosts(state, posts) {
      state.posts = posts;
    },
    setRelatedPosts(state, posts) {
      state.relatedPosts = posts;
    },
    setPagination(state, pagination) {
      state.pagination = pagination
    },
  },

  getters: {
    getBySlug: (state) => slug => {
      return state.mappedPosts[slug]
    },
  },

  state: defaultState(),
}
